module.exports = __webpack_public_path__ + "img/no product.fbaa3315.png";